import type { AuthProject, AuthUser } from '@/stores/auth';
import type { AvatarContentType } from '@bsod/contracts';
import { api } from './client';

export interface MeResponse {
  user: AuthUser;
  company: { id: string; name: string; slug: string };
  projects: AuthProject[];
}

export interface UpdateProfileDto {
  display_name?: string;
}

export interface ChangePasswordDto {
  current_password: string;
  new_password: string;
}

export interface UpdateAvatarDto {
  content_type: AvatarContentType;
  data_base64: string;
}

export const meApi = {
  getMe: () => api.get<MeResponse>('/me').then((r) => r.data),
  updateProfile: (dto: UpdateProfileDto) => api.patch('/me', dto).then(() => undefined),
  updateAvatar: (dto: UpdateAvatarDto) =>
    api.put<{ avatar_url: string }>('/me/avatar', dto).then((r) => r.data),
  removeAvatar: () => api.delete('/me/avatar').then(() => undefined),
  changePassword: (dto: ChangePasswordDto) => api.patch('/me/password', dto).then(() => undefined),
};
